@if (showSpinner) {
  <app-loader> </app-loader>
}
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  @if (isavailablefeature('view')) {
    <div class="apply-form-main mb-4">
      <div class="row mt-3">
        <div class="col-12">
          <div class="create-form pt-3 pl-4 pr-4 border" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <div class="mb-3">
              <h5>Add Media</h5>
            </div>
            <form #f="ngForm" (ngSubmit)="onSubmit(f)">
              <div class="media row text-secondary-light">
                <div class="col-12 ">
                  <div class="form-group ">
                    <input type="file" name="media_image" ngModel #media_image="ngModel"
                      accept=".mpg, .avi, .mov, .webm, .mp4, .png, .jpg, .jpeg" class=" form-control file-input"
                      (change)="onFileSelected($event)" />
                    </div>
                  </div>
                </div>
                <div class="media row text-secondary-light">
                  <div class="col-md-6 ">
                    <div class="form-group">
                      <select name="type" class="dropdown-toggle checks-dropdown form-control selectpicker" ngModel
                        #type="ngModel">
                        <option value="" disabled selected>Media Type</option>
                        <option value="image">Image</option>
                        <option value="video">Video</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-6 ">
                    <div class="form-group">
                      <input type="text" name="expiry_date" class="form-control" placeholder="Expiry Date"
                        onfocus="(this.type='date')" onblur="(this.type= this.value ? 'date' : 'text')" ngModel
                        #expiry_date="ngModel" />
                      </div>
                    </div>
                    <div class="media col-12 row text-secondary-light time-detail pr-0 mb-1">
                      <div class="col-2 buttons pr-0">
                        <div class="form-group">
                          <button type="button" (click)="onCancel(f)" class="btn cancel">
                            Cancel
                          </button>
                        </div>
                      </div>
                      @if (isavailablefeature('upload')) {
                        <div class="col-2 buttons  pr-0">
                          <button type="submit" class="btn apply">Upload</button>
                        </div>
                      }
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      }
    </main>